/**
 * Quanto e' largo lo schermo, detto in un posto solo.
 *
 * UNA soglia, 1024. Sotto e' un telefono, sopra e' la griglia.
 *
 * Nel foglio di stile ce n'erano tre che non coincidevano — 760, 761, 768 —
 * piu' i 1024 usati altrove: fra i 768 e i 1030 la pagina non era ne' una cosa
 * ne' l'altra, e un tablet in verticale prendeva pezzi dell'una e dell'altra.
 * Il numero sta scritto qui una volta e lo leggono sia il CSS sia il codice,
 * cosi' non possono piu' divergere.
 *
 * Si chiede al browser con matchMedia invece di misurare window.innerWidth a
 * ogni ridisegno: il browser lo sa gia', e avvisa lui quando cambia. Misurarlo
 * a mano significa leggere il layout, che costa, e farlo nel momento sbagliato.
 */

/** Sotto questa larghezza si disegna per il telefono. */
export const LARGHEZZA_TELEFONO = 1024;

const REGOLA = '(max-width: ' + (LARGHEZZA_TELEFONO - 1) + 'px)';

/** Vero se adesso siamo su uno schermo stretto. */
export function eTelefono() {
  return vale(REGOLA);
}

/* Una MediaQueryList per regola, tenuta: `.matches` e' sempre aggiornato
   dal browser, mentre crearne una a ogni domanda costava (eTelefono si
   chiede a ogni disegno, anche cento volte per una quota toccata). */
const liste = new Map();
let daChi = null;   /* se matchMedia viene sostituito (le prove lo fanno), si riparte */

function vale(regola) {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  if (daChi !== window.matchMedia) { liste.clear(); daChi = window.matchMedia; }
  let lista = liste.get(regola);
  if (!lista) {
    lista = window.matchMedia(regola);
    if (!lista) return false;
    liste.set(regola, lista);
  }
  return lista.matches;
}

/**
 * Chiama `quando(eTelefono)` a ogni cambio di larghezza.
 *
 * Restituisce la funzione per smettere di ascoltare: chi la chiama DEVE
 * invocarla quando si smonta, altrimenti resta un ascoltatore agganciato a un
 * componente che non c'e' piu' e React avvisa a ogni rotazione dello schermo.
 *
 * addEventListener su MediaQueryList non esiste in Safari prima della 14:
 * li' c'e' solo addListener. Si prova il moderno e si ricade sul vecchio,
 * perche' un telefono di qualche anno fa e' esattamente il pubblico di questa
 * pagina.
 */
export function osservaSchermo(quando) {
  return osserva(REGOLA, quando);
}

/**
 * SOTTO I 1680 PX LA GRIGLIA DEL COMPUTER PERDE LA COLONNA DEL NUMERO.
 *
 * Con data, numero, otto quote e soglia a misure fisse, su un portatile da
 * 1440 al nome della partita restavano due pixel. Il numero dell'evento lascia
 * il posto al nome (resta nella pagina della partita e nella schedina). Lo
 * decide il codice e non solo il CSS perche' la fascia del giorno copre le
 * prime colonne con un colSpan, che deve sapere quante sono.
 */
const REGOLA_SENZA_NUMERO = '(max-width: 1679px)';

export function senzaNumero() {
  return vale(REGOLA_SENZA_NUMERO);
}

export function osservaSenzaNumero(quando) {
  return osserva(REGOLA_SENZA_NUMERO, quando);
}

/**
 * FRA I 1024 E I 1279 PX LE QUOTE VANNO A SCHEDE.
 *
 * Tablet in orizzontale e portatili piccoli: col menu a lato e la schedina
 * al centro restano 500-700 px, e la riga con data, nome, otto quote e la
 * soglia non ci sta (a 1024 il nome della partita spariva). Li' si usa la
 * vista a schede del computer, la stessa che il backoffice puo' scegliere
 * per tutti (Sport › Vista prematch): due schede per riga, i segni sopra le
 * celle. Sotto i 1024 resta il telefono.
 */
const REGOLA_SCHEDE = '(max-width: 1279px)';

export function aSchede() {
  return vale(REGOLA_SCHEDE);
}

export function osservaASchede(quando) {
  return osserva(REGOLA_SCHEDE, quando);
}

function osserva(regola, quando) {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return function () {};
  }

  const lista = window.matchMedia(regola);
  const avvisa = function (e) {
    quando(e.matches);
  };

  if (lista.addEventListener) {
    lista.addEventListener('change', avvisa);
    return function () {
      lista.removeEventListener('change', avvisa);
    };
  }

  lista.addListener(avvisa);
  return function () {
    lista.removeListener(avvisa);
  };
}
